module.exports = __webpack_public_path__ + "img/H01060-01.69be2155.jpg";